let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("l5XQ1")).then(() => parcelRequire('l9IRD'));